import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-6 md:py-14 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto text-center" data-id="element-74">
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="flex flex-col items-center" data-id="element-75">
        <div className="w-24 h-24 md:w-32 md:h-32 mb-3 md:mb-4" data-id="element-76">
          <img src="https://cdn.magicpatterns.com/uploads/skkmeG6g3yqbwfR9Cri9Hv/garantia-7-dias-250.webp" alt="Garantía 7 días" className="w-full h-full object-contain" data-id="element-77" />
        </div>

        <h2 className="text-2xl md:text-4xl font-bold mb-3 md:mb-4" data-id="element-78">
          Riesgo Cero para vos.
        </h2>

        <p className="text-base md:text-lg text-text-muted leading-relaxed" data-id="element-79">
          Si el material no es lo que esperabas para tus clases técnicas, te
          devolvemos el 100% de tu dinero. Así de seguros estamos de nuestro
          trabajo.
        </p>
      </motion.div>
    </section>;
}